import * as fs from 'file-saver';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { strToolName, strVersion, default_toast_showtime, strMainHeadline, strToolNameHeadline } from './pages/Consts'
import { genMinMaxAvgNote, genMinMaxAvgPunkte, getDateTimeString } from './pages/Functions';

import { Container, Row, Col, Button } from 'react-bootstrap';
import NavbarTop from './pages/NavbarTop/NavbarTop';
import Navigation from './pages/Navigation/Navigation';
import Toasts from './pages/Toasts/Toasts';
import ModalAreYouSure from './pages/Modals/ModalAreYouSure/ModalAreYouSure';
import ModalConsentGate from "./pages/Modals/ModalConsentGate/ModalConsentGate";

import './side-menu.css';
import './main.css';
import './App.css';
// import logo_bw from './bw2.png';
import React, { PureComponent, createRef } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Home } from './pages/Home';
import MainGrid from './pages/MainGrid/MainGrid';
// import Grid from './pages/Grid';
import { PageNotFound } from './pages/PageNotFound';
import { EvaluationPerform } from './pages/Evaluation/EvaluationPerform';
import { ErrorBoundary } from './pages/ErrorBoundary';

import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-061232}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{ZSL_-_Zentrum_fr_Schulqualitt_und_Lehrerbildung_Baden_Wrttemberg}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Unterrichtsentwicklung_mit_Ergebnissen_von_Klassenarbeiten}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Unterrichtsentwicklung_mit_Ergebnissen_von_Klassenarbeiten}_need_to_be_licensed___{Unterrichtsentwicklung_mit_Ergebnissen_von_Klassenarbeiten}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_July_2025}____[v3]_[01]_MTc1MTY3MDAwMDAwMA==3bf5532b2a0046093e71d0c33ea08725");

const packageJson = require('../package.json');

const standardState = {
    clipboard: "no",
    criterion_a: "no",
    criterion_b: "no",
    criterion_c: "no",
    eloaded: "",
    statusNotice: "",
    klasse: '',
    schuljahr: '',
    fach: '',
    notenschluessel: 0,
    realMaxPoints: "",
    maxPunkte: [
        // [{ value: '' }, { value: '' }, { value: '3' }, { value: '5' }, { value: ' ' }],
        [{ value: '' }, { value: '' }, { value: ' ' }],
    ],
    abereiche: [
        // [{ value: '' }, { value: '' }, { value: 'I' }, { value: 'II' }],
        [{ value: '' }, { value: '' }],
    ],
    taskNames: [
        // [{ value: '' }, { value: '' }, { value: 'A1' }, { value: 'A2' }],
        [{ value: '' }, { value: '' }],
    ],
    namelessColsMaxPunkte: [
        { label: ' ', width: '100px' },
        { label: '  ', width: '100px' },
        // { label: 'A1', width: '50px' },
        // { label: 'A2', width: '50px' },
        // { label: 'Summe', width: '50px' }
    ],
    namelessColsAbereiche: [
        { label: ' ', width: '100px' },
        { label: '  ', width: '100px' },
        // { label: 'A1', width: '50px' },
        // { label: 'A2', width: '50px' }
    ],
    columns: [
        { label: 'Name', width: '100px' },
        { label: 'Vorname', width: '100px' },
        // { label: 'A1', width: '50px' },
        // { label: 'A2', width: '50px' },
        { label: 'Summe', width: '50px' },
        { label: 'Note', width: '50px' }
    ],
    grid: [
        // [{ value: 'Rossi' }, { value: 'Ana' }, { value: '1' }, { value: '3' }, { value: ' ' }, { value: ' ' }],
        // [{ value: 'Carrasco' }, { value: 'Valentino' }, { value: '2' }, { value: '4' }, { value: ' ' }, { value: ' ' }],
    ],
    helper: {
        modalAYS: {
            header: "",
            body: "",
            footer_cancel: "Abbrechen",
            footer_confirm: "Bestätigen",
            method_confirm: null,
            visible: false,
        },
        offcanvas: {
            show: true,
        },
        toasts: [
            // severity: info, warning, danger
        ],
        redirect: "",
        tooltips: true,
    },
};

class App extends PureComponent {

    handleCallbackCancelModalAreYouSure = () => {
        this.setState(prevState => {
            let updatedItem = { ...prevState.helper.modalAYS };
            updatedItem.visible = false;
            return { helper: { ...prevState.helper, modalAYS: updatedItem } };
        });
    }

    handleSetCriteria = (a, b, c) => {
        this.setState({
            criterion_a: a,
            criterion_b: b,
            criterion_c: c,
        });
        this.forceUpdate();
    }

    constructor(props) {
        super(props);
        this.state = JSON.parse(JSON.stringify(standardState));
        this.standardState = JSON.parse(JSON.stringify(standardState));
        this.handleUnload = this.handleUnload.bind(this);
        this.renderHTMLHeader();

        this.gridRef = createRef();
    }

    handleCancelModal = () => {
        this.setState(prevState => {
            let updatedItem = { ...prevState.helper.modal };
            updatedItem.visible = false;
            return { helper: { ...prevState.helper, modal: updatedItem } };
        });
    }

    handleCallbackToggleToast = (id) => {
        this.setState(prevState => {
            const updatedToasts = prevState.helper.toasts.map(toast => {
                if (toast.id === id) {
                    return { ...toast, visible: !toast.visible };
                }
                return toast;
            });
            return { helper: { ...prevState.helper, toasts: updatedToasts } };
        });
    }

    handleCallbackToggleOffCanvas = () => {
        this.setState(prevState => ({
            helper: {
                ...this.state.helper,
                offcanvas: {
                    show: !prevState.helper.offcanvas.show,
                }
            }
        }));
    }

    handleChangeKlasse = (newValue) => {
        this.setState(prevState => ({
            klasse: newValue
        }));
    }

    handleChangeSchuljahr = (newValue) => {
        this.setState(prevState => ({
            schuljahr: newValue
        }));
    }

    handleChangeRealMaxPoints = (target) => {
        // console.log(target);
        let invalid_chars = /[^0-9]/g;
        let setVal = target.value.replace(invalid_chars, "");
        target.value = setVal;
        // console.log(setVal);
        this.setState(prevState => ({
            realMaxPoints: setVal
        }));
    }

    handleChangeFach = (newValue) => {
        this.setState(prevState => ({
            fach: newValue
        }));
    }

    handleChangeSockelOben = (target) => {
        let invalid_chars = /[^0-9]/g;
        let setVal = Number(target.value.replace(invalid_chars, ""));
        let actMP = Number(this.state.maxPunkte[0].slice(-1)[0].value);

        let sockelUnten = Number(this.state.sockelUnten);

        if (setVal > actMP) {
            setVal = actMP;
        }
        target.value = setVal;

        if (setVal < sockelUnten) {
            sockelUnten = setVal;
        }

        this.setState(prevState => ({
            sockelOben: setVal,
            sockelUnten: sockelUnten
        }));
        // this.forceUpdate();
    }

    handleChangeSockelUnten = (target) => {
        let invalid_chars = /[^0-9]/g;
        let setVal = Number(target.value.replace(invalid_chars, ""));
        let actMP = Number(this.state.maxPunkte[0].slice(-1)[0].value);

        let sockelOben = Number(this.state.sockelOben);

        if (setVal > actMP) {
            setVal = actMP;
        }
        target.value = setVal;

        if (setVal > sockelOben) {
            sockelOben = setVal;
        }

        this.setState(prevState => ({
            sockelUnten: setVal,
            sockelOben: sockelOben,
        }));
    }

    handleChangeKnick = (target) => {
        let invalid_chars = /[^0-9]/g;
        let setVal = Number(target.value.replace(invalid_chars, ""));
        let actMP = Number(this.state.maxPunkte[0].slice(-1)[0].value);

        if (setVal > actMP) {
            setVal = actMP;
        }
        target.value = setVal;
        this.setState(prevState => ({
            knick: setVal
        }));
    }

    // handleClipboardData = (cd) => {
    //     this.state.grid = [];
    //     let gr = this.state.grid;
    //     let lines = cd.split('\n');
    //     for (var i = 0; i < lines.length; i++) {
    //         let cells = lines[i].split('\t');
    //         let rowGr = [];
    //         for (var j = 0; j < cells.length; j++) {
    //             rowGr.push({ value: cells[j].trim() });
    //         }
    //         gr.push(rowGr);
    //     }
    // }

    handleClipboardData = (dataArray) => {
        console.log("hi from", dataArray);
        // Reset the grid array
        let gr = [];

        // Loop through the two-dimensional array (dataArray)
        for (let i = 0; i < dataArray.length; i++) {
            let rowGr = [];

            // Loop through each field (cell) in the current row (i.e., dataArray[i])
            for (let j = 0; j < dataArray[i].length; j++) {
                // Add the cell value to the rowGr, trimming whitespace
                rowGr.push({ value: dataArray[i][j].trim() });
            }

            // Push the processed row into the grid array
            gr.push(rowGr);
        }
        console.log(gr);

        // Update the state with the processed grid array
        this.setState({ grid: gr });
    }


    handleChangeSumOfPupil = (idx, x) => {
        let gr = this.state.grid;
        if (idx > 3 && gr[idx - 4] !== undefined) {
            // console.log("SUM CHANGED!" + idx + " ==> " + x);
            // console.log(gr[idx - 4][gr[idx - 4].length-2].value + "=>" + x);
            gr[idx - 4][gr[idx - 4].length - 2] = { value: x };
            this.setState(prevState => ({
                grid: gr
            }));
            // this.forceUpdate();
        }
    }

    handleSetMaxPointsSum = (sum) => {
        let mp = this.state.maxPunkte;
        mp[0][mp[0].length - 1] = { value: sum };

        this.setState((prevState) => ({
            sockelOben: sum < prevState.sockelOben ? sum : prevState.sockelOben,
            sockelUnten: sum < prevState.sockelUnten ? sum : prevState.sockelUnten,
            knick: sum < prevState.knick ? sum : prevState.knick,
            maxPunkte: mp
        }));
    }

    handleGetMaxPointsSum = () => {
        let mp = this.state.maxPunkte;
        return Number(mp[0][mp[0].length - 1].value);
    }

    handleChangeNumOfTasksXX = (num) => {
        const { abereiche, columns, maxPunkte, namelessColsAbereiche, namelessColsMaxPunkte, taskNames } = this.state;

        const newTaskLabel = 'A' + (columns.length - 3);

        const updatedAbereiche = [...abereiche];
        // const updatedColumns = this.state.columns;
        const updatedMaxPunkte = [...maxPunkte];
        const updatedNamelessColsAbereiche = [...namelessColsAbereiche];
        const updatedNamelessColsMaxPunkte = [...namelessColsMaxPunkte];
        const updatedTaskNames = [...taskNames];

        if (num > 0) {
            updatedAbereiche[0].splice(-2, 0, { value: '' });
            columns.splice(-2, 0, { label: newTaskLabel, width: '50px' });
            updatedMaxPunkte[0].splice(-1, 0, { value: '0' });
            updatedNamelessColsAbereiche.splice(-2, 0, { label: newTaskLabel, width: '50px' });
            updatedNamelessColsMaxPunkte.splice(-2, 0, { label: newTaskLabel, width: '50px' });
            updatedTaskNames[0].splice(-1, 0, { value: newTaskLabel });
        }
        else if (num < 0) {
            updatedAbereiche[0].splice(-3, 1);
            columns.splice(-3, 1);
            updatedMaxPunkte[0].splice(-2, 1);
            updatedNamelessColsAbereiche.splice(-2, 1);
            updatedNamelessColsMaxPunkte.splice(-2, 1);
            updatedTaskNames[0].splice(-2, 1);
        }

        // this.setState({
        //     columns: columns
        // });
        // this.forceUpdate();
    };

    handleChangeNumOfTasks = (num) => {
        console.log("OK I AM CALLED")
        const { abereiche, columns, maxPunkte, namelessColsAbereiche, namelessColsMaxPunkte, taskNames } = this.state;

        const tNumber = columns.length - 3;
        if (num > 0) {
            console.log(">>> PUSHING: " + tNumber);
            abereiche[0].push({ value: ' ' });
            columns.splice(-2, 0, { label: 'A' + tNumber, width: '50px' });
            maxPunkte[0].push({ value: '0' });
            namelessColsAbereiche.push({ label: 'A' + tNumber, width: '50px' });
            namelessColsMaxPunkte.push({ label: 'A' + tNumber, width: '50px' });
            // taskNames[0].push({ value: 'A' + tNumber });
            taskNames[0].push({ value: 'A' + tNumber });
        }
        else if (num < 0) {
            abereiche[0].splice(-1, 1);
            columns.splice(-3, 1);
            maxPunkte[0].splice(-1, 1);
            namelessColsAbereiche.splice(-1, 1);
            namelessColsMaxPunkte.splice(-1, 1);
            taskNames[0].splice(-1, 1);
        }

        this.setState({
            abereiche: abereiche,
            columns: columns,
            taskNames: taskNames,
            maxPunkte: maxPunkte,
            namelessColsAbereiche: namelessColsAbereiche,
            namelessColsMaxPunkte: namelessColsMaxPunkte,
            taskNames: taskNames,
        });
        this.forceUpdate();

        console.log(this.state);
    }

    handleChangeNumOfPupils = (num) => {
        const { grid, columns } = this.state;
        const numTasks = columns.length - 4;

        // Create a shallow copy of the grid to maintain immutability
        const newGrid = [...grid];

        if (num > 0) {
            // Add a new row with empty values
            const newRow = [{ value: '' }, { value: '' }];  // First two empty values

            // Add empty values for each task
            for (let j = 0; j < numTasks; j++) {
                newRow.push({ value: '' });
            }

            // Add two more empty values at the end
            newRow.push({ value: '' }, { value: '' });

            // Add the new row to the copied grid
            newGrid.push(newRow);
        } else if (num < 0 && newGrid.length > 0) {
            // Remove the last row
            newGrid.pop();
        }

        // Update the state with the new grid
        this.setState({ grid: newGrid });
    }

    // handleChangeNumOfPupils = (num) => {
    //   let gr = this.state.grid;
    //   let c = this.state.columns;
    //   let numTasks = c.length - 4;

    //   if (num > 0) {
    //     let rowGr = [];
    //     rowGr.push({ value: '', value: '' });

    //     for (var j = 0; j < numTasks; j++) {
    //       rowGr.push({ value: '' });
    //     }

    //     rowGr.push({ value: '', value: '' });
    //     gr.push(rowGr);
    //   }

    //   if (num < 0) {
    //     gr.pop();
    //   }

    //   this.setState(prevState => ({
    //     grid: gr
    //   }));
    //   this.forceUpdate();
    // }

    handleChangeNotenschluessel(event) {
        const gk = event.target.value;
        this.setState({ notenschluessel: gk });
        event.target.value = "0";

        let gr = this.state.grid;
        let mp = this.state.maxPunkte;
        // console.log(mp);
        let max = Number(mp[0][mp[0].length - 1].value);
        // console.log(max);
        for (var row = 0; row < gr.length; row++) {
            let p = Number(gr[row][gr[row].length - 2].value);
            let note = this.berechneNote(Number(gk), p, max);

            gr[row][gr[row].length - 1] = { value: '' + note };
        }

        // gr.forEach(item => {
        //   var sum = 0;
        //   for (var i = 2; i < item.length - 2; i++) {
        //     sum += Number(item[i].value);
        //   }
        //   item[item.length - 2] = { value: '' + sum };
        // });

        this.setState(prevState => ({
            grid: gr
        }));
        this.forceUpdate();
    }

    genMinMaxAvgPunkte() {
        let g = this.state.grid;
        let pS = {
            "num": 0,
            "minsum": 9999,
            "maxsum": -1,
            "sumsum": 0
        }
        g.forEach(item => {
            var sum = 0;
            for (var i = 2; i < item.length - 2; i++) {
                sum += Number(item[i].value);
            }
            if (sum > pS.maxsum) {
                pS.maxsum = sum;
            }
            if (sum < pS.minsum) {
                pS.minsum = sum;
            }
            pS.sumsum += sum;
            pS.num++;
        });
        return pS.minsum + " / " + pS.maxsum + " / " + Math.round(((pS.sumsum / pS.num) + Number.EPSILON) * 100) / 100;
    }

    genMinMaxAvgNote() {
        let g = this.state.grid;
        let gS = {
            "num": 0,
            "ming": 9999,
            "maxg": -1,
            "sumg": 0
        }
        g.forEach(item => {
            var grade = Number(item[item.length - 1].value);
            if (grade > gS.maxg) {
                gS.maxg = grade;
            }
            if (grade < gS.ming) {
                gS.ming = grade;
            }
            gS.sumg += grade;
            gS.num++;
        });
        return gS.ming + " / " + gS.maxg + " / " + Math.round(((gS.sumg / gS.num) + Number.EPSILON) * 100) / 100;;
    }

    genFilename(json = true) {
        // genFilename = () => {
        var invalid_chars = /[^a-zA-Z0-9_-]/g;
        const fn = `${new Date().toISOString().slice(0, 10)}-Klassenarbeit-${this.state.schuljahr.replace(invalid_chars, "")}-${this.state.fach.replace(invalid_chars, "")}-${this.state.klasse.replace(invalid_chars, "")}.json`;
        if (json) {
            return fn;
        }
        else {
            return fn.replace(/\.json$/, '.csv');
        }
        // return this.state.schuljahr.replace(invalid_chars, "") + "-" +
        //     this.state.fach.replace(invalid_chars, "") + "-" +
        //     this.state.klasse.replace(invalid_chars, "") + ".json";
    }

    // genFilenameCSV() {
    //     // genFilename = () => {
    //     var invalid_chars = /[^a-zA-Z0-9_-]/g;
    //     return this.state.schuljahr.replace(invalid_chars, "") + "-" +
    //         this.state.fach.replace(invalid_chars, "") + "-" +
    //         this.state.klasse.replace(invalid_chars, "") + ".csv";
    // }

    onBtPrint = () => {
        window.print();
    }

    renderStatusBlock = () => {
        return (
            <>
                <form>
                    <fieldset>
                        <legend>Durchschnitt (Minimum / Maximum / Mittel)</legend>
                        Punkte: <span className="bold">{this.genMinMaxAvgPunkte()}</span><br />
                        Note: <span className="bold">{this.genMinMaxAvgNote()}</span>
                        {/* <input type="text" id="txtDurchschnitt" value="bumm" readOnly /> */}
                    </fieldset>
                </form>
            </>
        )
    }

    handleStatusNotice = () => {
        const s = this.state.statusNotice;
        return (s !== "" ? s &&
            <div className="innerStatusInfoBox">
                {s}
                <a className="pointerFinger innerStatusInfoBoxRemover" onClick={() => this.dismissStatusNotice()}>&#x2718;</a>
            </div> : ""
        );
    }

    dismissStatusNotice = () => {
        this.setState(prevState => ({
            statusNotice: ""
        }));
        this.forceUpdate();
    }

    handleSetStatusInfo = (s) => {
        this.setState(prevState => ({
            statusNotice: s
        }));
        this.forceUpdate();
    }

    handleSetGK = (s) => {
        this.setState(prevState => ({
            notenschluessel: s
        }));
        this.forceUpdate();
    }

    handleSetRealMaxPoints = (s) => {
        console.log("REAL MAX POINTS: " + s);
        this.setState(prevState => ({
            realMaxPoints: s
        }));
        // this.forceUpdate();
    }

    handleGetGK = () => {
        return this.state.notenschluessel;
    }

    handleGetRealMaxPoints = () => {
        return this.state.realMaxPoints;
    }

    setClipBoardAccess = (s) => {
        this.setState(prevState => ({
            clipboard: s
        }));
        this.forceUpdate();
    }

    async checkClipBoardAccessWrite() {
        const queryOpts = { name: 'clipboard-write', allowWithoutGesture: false };
        const query = await navigator.permissions.query(queryOpts);
        return query;
    }

    async checkClipBoardAccessRead() {
        const queryOpts = { name: 'clipboard-read', allowWithoutGesture: false };
        var query = await navigator.permissions.query(queryOpts);
        console.log(query.state);
        console.log("SCHEIXX DIE WAND AN");
        setTimeout(() => {
            console.log(query.state);
        }, 1000);

        if (query.state === "granted") {
            return "JA"
        } else {
            return "NOE";
        }
    }

    async genFileNamePickerDialogCSV(workLoad) {
        const opts = {
            suggestedName: this.genFilenameCSV(),
            types: [{
                description: 'CSV Datei',
                accept: { 'text/csv': ['.csv'] },
            }],
        };
        const handle = await window.showSaveFilePicker(opts);
        const writable = await handle.createWritable();
        await writable.write(workLoad);
        await writable.close();
        alert("Klassenarbeit exportiert.\nDateiname: " + handle.name + "\nDie Daten wurden auch in Ihre Zwischenablage kopiert.\nSie können diese z.B. in eine Tabellenkalulation einfügen.");
        return handle;
    }

    async genFileNamePickerDialog(workLoad) {
        const opts = {
            suggestedName: this.genFilename(),
            types: [{
                description: 'JSON Datei',
                accept: { 'application/json': ['.json'] },
            }],
        };

        try {
            const handle = await window.showSaveFilePicker(opts);
            const writable = await handle.createWritable();
            await writable.write(workLoad);
            await writable.close();
            this.handleCallbackSetNotice("Die aktuelle Klassenarbeit wurde unter dem Dateinamen '" + handle.name +
                "' auf Ihrem lokalen Dateisystem gespeichert.",
                "Klassenarbeit gespeichert",
                "info");
        } catch (e) {
            console.error(e);
            this.handleCallbackSetNotice("Die aktuelle Klassenarbeit wurde nicht gespeichert.",
                "Speichern abgebrochen",
                "warning");
        }
    }

    handleDirectSave = () => {
        this.goModal('confirm_exam_save_auto_filename');
    }

    handleDirectSaveExecute = (fn) => {
        this.handleCallbackCancelModalAreYouSure();
        try {
            const saveState = {
                ...this.state,
                helper: { ...standardState.helper }
            };
            const textFile = new Blob([JSON.stringify(saveState)], { type: 'application/json' });

            let dlFileName = fn;

            fs.saveAs(textFile, dlFileName);

            this.injectToast("Klassenarbeit gespeichert",
                "Die aktuelle Klassenarbeit wurde unter dem Dateinamen '" + dlFileName +
                "' auf Ihrem lokalen Dateisystem gespeichert.",
                default_toast_showtime,
                new Date().toLocaleString(),
                "info",
                true);
        } catch (error) {
            console.error("Error saving file:", error);
            this.injectToast("Speichern fehlgeschlagen",
                "Die aktuelle Klassenarbeit konnte nicht gespeichert werden. Haben Sie eventuell keine Berechtigung?",
                default_toast_showtime,
                new Date().toLocaleString(),
                "alert",
                true);
        }
    };
    // handleDirectSaveExecute = (fn) => {
    //     const textFile = new Blob([JSON.stringify(this.state)], { type: 'application/json' });
    //     const element = document.createElement("a");
    //     element.href = URL.createObjectURL(textFile);
    //     element.download = fn;
    //     document.body.appendChild(element);
    //     element.click();
    //     document.body.removeChild(element);
    // }

    handleDirectSaveCSV = () => {
        console.log("IMPLEMENT ME DIRECT SAVE CSV");
    }

    fixStateDataFromGridFromApp = () => {
        if (this.gridRef && this.gridRef.current && this.gridRef.current.getGridApi()) {
            // console.log("fixing from grid in app");
            this.fixStateDataFromGrid(this.gridRef.current.getGridApi());
        }
        else {
            console.warn("cannot access grid, data might be outdated");
        }
    }

    fixStateDataFromGrid = (ref) => {

        const cl = this.state.columns;
        cl.length = 0;
        cl[0] = { label: 'Name', width: '100px' };
        cl[1] = { label: 'Vorname', width: '100px' };

        const tn = this.state.taskNames;
        // const tn = [];
        tn[0] = [{ value: '' }, { value: '' }];

        const ab = this.state.abereiche;
        // const ab = [];
        ab[0] = [{ value: '' }, { value: '' }];

        const mp = this.state.maxPunkte;
        // const mp = [];
        mp[0] = [{ value: '' }, { value: '' }, { value: ' ' }];

        const ncMaxP = this.state.namelessColsMaxPunkte;
        // const ncMaxP = [];
        ncMaxP.length = 0;
        ncMaxP[0] = { label: ' ', width: '100px' };
        ncMaxP[1] = { label: ' ', width: '100px' };

        const ncAB = this.state.namelessColsAbereiche;
        // const ncAB = [];
        ncAB.length = 0;
        ncAB[0] = { label: ' ', width: '100px' };
        ncAB[1] = { label: ' ', width: '100px' };

        const g = this.state.grid;
        // const g = [];

        const cRef = ref.getColumnDefs();
        let numTasks = cRef.length - 5;
        // const numTasks = this.state.columns.length - 4; // rather use grid info!

        // console.log("Anzahl Aufgaben: " + numTasks);

        const gTn = ref.getRowNode('id1').data;
        const gAb = ref.getRowNode('id2').data;
        const gMp = ref.getRowNode('id3').data;

        // console.log("cl", cl);

        for (let i = 0; i < numTasks; i++) {
            ab[0][i + 2] = { value: (gAb['a' + (i + 1)]) === undefined ? "" : gAb['a' + (i + 1)] };
            tn[0][i + 2] = { value: (gTn['a' + (i + 1)]) === undefined ? "" : gTn['a' + (i + 1)] };
            mp[0][i + 2] = { value: (gMp['a' + (i + 1)]) === undefined ? "0" : gMp['a' + (i + 1)] };

            cl[i + 2] = { label: 'A' + (i + 1), width: '50px' };

            ncMaxP[i + 2] = { label: 'A' + (i + 1), width: '50px' };
            ncAB[i + 2] = { label: 'A' + (i + 1), width: '50px' };
        }
        mp[0][numTasks + 2] = { value: gMp['summe'] };
        ncMaxP[numTasks + 2] = { label: 'Summe', width: '50px' };
        cl[numTasks + 2] = { label: 'Summe', width: '50px' };
        cl[numTasks + 3] = { label: 'Note', width: '50px' };

        // console.log("cl", cl);

        ref.forEachNode((rowNode, index) => {
            if (index > 3) {
                // console.log(rowNode.data);
                g[index - 4] = [];
                g[index - 4][0] = { value: rowNode.data['c0'] };
                g[index - 4][1] = { value: rowNode.data['c1'] };
                for (let i = 0; i < numTasks; i++) {
                    g[index - 4][i + 2] = { value: (rowNode.data['a' + (i + 1)]) === undefined ? "0" : rowNode.data['a' + (i + 1)] };
                }
                g[index - 4][numTasks + 2] = { value: rowNode.data['summe'] };
                g[index - 4][numTasks + 3] = { value: rowNode.data['note'] };
            }
        });

        this.setState(prevState => ({
            criterion_a: "no",
            criterion_b: "no",
            criterion_c: "no",
            columns: cl,
            taskNames: tn,
            abereiche: ab,
            maxPunkte: mp,
            namelessColsMaxPunkte: ncMaxP,
            namelessColsAbereiche: ncAB,
            grid: g,
        }));
        this.forceUpdate();
    }

    handleSave = (ref) => {
        // console.log(this.state);
        // console.log("hello from handle save");
        if (this.gridRef && this.gridRef.current && this.gridRef.current.getGridApi()) {
            // console.log("fixing from grid in save");
            this.fixStateDataFromGrid(this.gridRef.current.getGridApi());
        }
        else {
            console.warn("cannot access grid, data might be outdated");
        }

        const saveState = {
            ...this.state,
            helper: { ...standardState.helper }
        };

        const workLoad = new Blob([JSON.stringify(saveState)], { type: 'application/json' });

        if (window.showSaveFilePicker) {
            this.genFileNamePickerDialog(workLoad);
        }
        else {
            this.handleDirectSave();
        }
    }

    handleSaveCSV = () => {
        this.goModal('confirm_exam_save_auto_filename_csv');
    }

    handleSaveCSVExecute = (fn) => {
        this.handleCallbackCancelModalAreYouSure();

        try {
            if (this.gridRef.current && this.gridRef.current.getGridApi()) {
                this.gridRef.current.getGridApi().exportDataAsCsv({
                    fileName: fn,
                });
            }

            this.injectToast("Klassenarbeit exportiert",
                "Die aktuelle Klassenarbeit wurde unter dem Dateinamen '" + fn +
                "' auf Ihrem lokalen Dateisystem im CSV-Format gespeichert.",
                default_toast_showtime,
                new Date().toLocaleString(),
                "info",
                true);
        } catch (error) {
            console.error("Error saving file:", error);
            this.injectToast("Export fehlgeschlagen",
                "Die aktuelle Klassenarbeit konnte nicht exportiert werden. Haben Sie eventuell keine Berechtigung?",
                default_toast_showtime,
                new Date().toLocaleString(),
                "alert",
                true);
        }
    };

    // handleSaveCSV = (ref) => {
    //     this.fixStateDataFromGrid(ref);
    //     const empty = '""';
    //     const eol = "\n";
    //     var csvData = "\uFEFF";

    //     let gr = this.state.grid;

    //     let cab = this.state.namelessColsAbereiche;
    //     let ab = this.state.abereiche;
    //     let tn = this.state.taskNames;
    //     let mp = this.state.maxPunkte;

    //     csvData += empty + ";" + empty + ";";
    //     var col;
    //     for (col = 2; col < cab.length; col++) {
    //         csvData += '"' + tn[0][col].value + '";';
    //     }
    //     csvData += '"Summe";"Note"' + eol;

    //     csvData += '"Anforderungsbereiche";' + empty + ';';
    //     for (col = 2; col < ab[0].length; col++) {
    //         csvData += '"' + ab[0][col].value + '";';
    //     }
    //     csvData += empty + ";" + empty + eol;

    //     csvData += '"Maximalpunkte";' + empty + ';';

    //     for (col = 2; col < mp[0].length; col++) {
    //         csvData += '"' + mp[0][col].value + '";';
    //     }
    //     csvData += empty + eol;

    //     csvData += '"Name";"Vorname";';
    //     for (let i = 0; i < (mp[0].length - 2); i++) {
    //         csvData += empty + ";";
    //     }
    //     csvData += empty + eol;

    //     for (var row = 0; row < gr.length; row++) {
    //         for (col = 0; col < gr[row].length; col++) {
    //             csvData += '"' + gr[row][col].value + '";';
    //         }
    //         csvData = csvData.slice(0, -1);
    //         csvData += eol;
    //     }
    //     const dotReplaceRegeEx = /[\.]/g;
    //     csvData = csvData.replace(dotReplaceRegeEx, ',');

    //     navigator.clipboard.writeText(csvData).then(function () {
    //         console.log('Async: Copying to clipboard was successful!');
    //     }, function (err) {
    //         console.error('Async: Could not copy text: ', err);
    //     });

    //     if (window.showSaveFilePicker) {
    //         const dlFileHandle = this.genFileNamePickerDialogCSV(csvData);
    //     }
    //     else {
    //         this.handleDirectSaveCSV();
    //     }
    // }

    // genFilename() {
    //   var invalid_chars = /[^a-zA-Z0-9_-]/g;
    //   return "beautiful_filename.json";
    // }

    componentDidMount() {
        window.addEventListener('beforeunload', this.handleUnload);
        window.addEventListener('unload', this.handleUnload);

        // if (this.gridRef.current) {
        //     console.log('Grid API:', this.gridRef.current.getGridApi());
        //     console.log('Grid Column API:', this.gridRef.current.getGridColumnApi());
        // }
    }

    setCurrentRedirect = (s) => {
        this.setState(prevState => ({
            helper: {
                ...this.state.helper,
                redirect: s,
            }
        }));
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log("Component DID UPDATE");
        // console.log("state", this.state.helper.redirect);
        // console.log("prev", prevState.helper.redirect);
        if (this.state.helper.redirect !== "") {
            this.setState(prevState => ({
                helper: {
                    ...prevState.helper,
                    redirect: "",
                }
            }));
        }
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleUnload);
        window.removeEventListener('unload', this.handleUnload);
    }

    handleUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
    }

    renderHTMLHeader = () => {
        document.title = "DGSE: " + strToolName + " " + packageJson.version;
    }

    handleCallbackWIPModal = () => {
        console.log("WIP Modal");
        this.goModal('wip');
    }

    handleCallbackSetNotice = (text, header = "change me", severity = "info") => {
        // console.log("geeeze im called...");
        this.injectToast(
            header,
            text,
            default_toast_showtime,
            new Date().toLocaleString(),
            severity,
            true);
    }

    injectToast = (header, body, showtime, timestamp, severity, visible) => {
        this.setState(prevState => {

            const updatedToasts = [...prevState.helper.toasts];
            const tLen = updatedToasts.length;

            const newToast = {
                id: tLen + 1,
                header: header,
                body: body,
                showtime: showtime,
                timestamp: timestamp,
                severity: severity,
                visible: visible,
            };
            updatedToasts.push(newToast);
            return { helper: { ...prevState.helper, toasts: updatedToasts } };
        });
    }

    handleFileLoadClick = (e) => {
        // dummy function
        console.log("Hello from Dummy Function")
    }

    handleFileLoadChange = (e) => {
        // console.log("Hello from handleFileLoadChange");
        e.preventDefault();

        if (e.target.files.length > 0) {
            const files = e.target.files;
            const file = files[0];

            // console.log(file.type);

            if (file.type.startsWith("application/json")) {
                // console.log("reading file");
                const reader = new FileReader();

                reader.onloadend = (e) => {
                    try {
                        if (e.target.readyState === FileReader.DONE) {
                            const fContent = e.target.result;
                            let fJSON = JSON.parse(fContent);

                            if (!fJSON.hasOwnProperty('taskNames')) {
                                const numTasks = fJSON.abereiche[0].length;
                                fJSON['taskNames'] = [];
                                fJSON['taskNames'][0] = [];
                                fJSON['taskNames'][0][0] = { value: "" };
                                fJSON['taskNames'][0][1] = { value: "" };

                                for (let i = 2; i < numTasks; i++) {
                                    fJSON['taskNames'][0][i] = { value: "A" + (i - 1) };
                                }
                            }

                            if (!fJSON.helper) {
                                fJSON.helper = {
                                    modalAYS: {
                                        header: "",
                                        body: "",
                                        footer_cancel: "Abbrechen",
                                        footer_confirm: "Bestätigen",
                                        method_confirm: null,
                                        visible: false,
                                    },
                                    offcanvas: {
                                        show: true,
                                    },
                                    toasts: [
                                        // severity: info, warning, danger
                                    ],
                                    redirect: "",
                                    tooltips: true
                                };
                            } else {
                                if (typeof fJSON.helper.tooltips === "undefined") {
                                    fJSON.helper.tooltips = true;
                                }
                            }

                            // console.log(fJSON);

                            // fJSON['eloaded'] = new Date().toLocaleString('de-DE', { timeZone: 'Europe/Berlin' });
                            fJSON['eloaded'] = Math.floor(Date.now() / 1000); // Returns the current timestamp in seconds

                            this.setState(() => fJSON);
                            // this.forceUpdate();
                            this.handleCallbackSetNotice("Die Klassenarbeit " + file.name + " wurde erfolgreich geladen.", "Klassenarbeit geladen", "info");
                            // this.setCurrentRedirect("/erfassung");
                            // this.forceUpdate();
                        }

                    }
                    catch (error) {
                        console.error("An error occurred while processing the file:", error);
                        this.handleCallbackSetNotice("Es gab einen Fehler beim Laden der Datei " + file.name + ". Überprüfen Sie bitte das Format. Versuchen Sie vielleicht eine Auswertung statt einer Klassenarbeit einzuspielen?", "Fehler beim Laden", "danger");
                    }
                };
                reader.readAsText(file);
            }
            else {
                this.handleCallbackSetNotice("Die Klassenarbeit " + file.name + " konnte nicht geladen werden. " +
                    "Sie können nur eine Klassenarbeit einspielen, die mit dieser Anwendung erstellt wurde. Bitte prüfen Sie das Dateiformat.",
                    "Klassenarbeit nicht geladen",
                    "warning");
            }
            e.target.value = "";
        }
    }

    handleSetLoadedJSON = (fJSON) => {
        this.setState(prevState => fJSON);
        this.forceUpdate();
    }

    handleCallbackToggleTooltips = () => {
        this.setState(prevState => ({
            helper: {
                ...this.state.helper,
                // tooltips: !this.state.helper.tooltips,
                tooltips: !prevState.helper.tooltips,
            }
        }));
        this.handleCallbackSetNotice("Sie haben die Anzeige der Tooltips in der Anwendung " + (this.state.helper.tooltips ? "deaktiviert" : "aktiviert") + ".", "Anzeige der Tooltips", "info");
    }

    // handleFileLoadChange = (e, x) => {
    //   e.preventDefault();
    //   if (e.target.files.length > 0) {
    //     const files = e.target.files;
    //     const file = files[0];
    //     if (file.type.startsWith("application/json")) {
    //       const reader = new FileReader();
    //       reader.onloadend = (function (theFile) {
    //         return function (e) {
    //           if (e.target.readyState === FileReader.DONE) {
    //             const fContent = e.target.result;
    //             let fJSON = JSON.parse(fContent);

    //             if (!fJSON.hasOwnProperty('taskNames')) {
    //               const numTasks = fJSON.abereiche[0].length;
    //               fJSON['taskNames'] = [];
    //               fJSON['taskNames'][0] = [];
    //               fJSON['taskNames'][0][0] = { value: "" };
    //               fJSON['taskNames'][0][1] = { value: "" };

    //               for (let i = 2; i < numTasks; i++) {
    //                 fJSON['taskNames'][0][i] = { value: "A" + (i - 1) };
    //               }
    //             }
    //             x.setState(prevState => fJSON)
    //             // x.forceUpdate();
    //             // console.log(x);
    //           }
    //         };
    //       })(file);
    //       reader.readAsText(file);
    //     }
    //     e.target.value = "";
    //   }
    // }


    // testCallBack = () => {
    testCallBack() {
        console.log("CALL BACK TEST XXX")
    }

    readClipboardContents = () => {

        // navigator.permissions.query({ name: 'clipboard-read' }).then(function (result) {
        //   console.log("HOORAY" + result.state)
        //   if (result.state === 'granted') {
        //     // this.state.clipboard = "yes";
        //     // console.log(state)
        //     // this.setState(prevState => ({
        //     //   clipboard: "yes",
        //     // }));
        //     // this.forceUpdate();
        //   }
        // });
        navigator.clipboard
            .readText()
            // .read()
            .then((clipText) => {
                console.log(clipText);
                let lines = clipText.split('\n');

                lines.map(function (item) {
                    let tabs = item.trim().split('\t');
                    console.log(tabs);
                    console.log("should add " + lines.length + " results with " +
                        tabs.length + " entries each");
                })

            });
    }

    handleReset = () => {
        window.location.reload();
    }

    handleCallbackReset(ret) {
        // noop
        // this.setState(prevState => {
        //   let updatedItem = { ...prevState.helper.modalAYS };
        //   updatedItem.header = ret.header;
        //   updatedItem.body = ret.body;
        //   updatedItem.footer_cancel = ret.footer_cancel;
        //   updatedItem.footer_confirm = ret.footer_confirm;
        //   updatedItem.method_confirm = this.machineReset;
        //   updatedItem.visible = true;
        //   return { helper: { ...prevState.helper, modalAYS: updatedItem } };
        // })
    }

    goModal = (which) => {
        let mData = [];
        let fix = 0;
        // console.log("goModal: " + which);
        if (which === 'reset') {
            mData.push("Wollen Sie die Anwendung wirklich zurücksetzen?");
            mData.push("Bitte bestätigen Sie, dass Sie die Anwendung neu starten wollen. " +
                "Ihr aktueller Bearbeitungsstand geht dabei verloren. Diese Aktion kann nicht rückgängig gemacht werden.");
            mData.push("Nein!");
            mData.push("Ja, zurücksetzen!");
            mData.push((e) => window.location.reload());
            mData.push(true);
            fix = 1;
        }
        else if (which === 'wip') {
            mData.push("In Arbeit...");
            mData.push("Die von Ihnen gewünschte Funktionalität ist aktuell leider noch nicht verfügbar. " +
                "Versuchen Sie es später noch einmal.");
            mData.push("");
            mData.push("OK, verstanden!");
            mData.push(() => { this.handleCallbackCancelModalAreYouSure(); });
            mData.push(true);
            fix = 1;
        }
        else if (which === 'confirm_print_current_view') {
            const fn = this.genFilename();
            mData.push("Aktuelle Ansicht drucken? Notenliste hier nicht möglich.");
            mData.push('Möchten Sie die aktuelle Ansicht drucken? Wenn Sie eine Notenliste drucken wollen, ' +
                'wechseln Sie bitte zuerst zu "Klassenarbeit erfassen", damit alle Daten aktuell sind.');
            mData.push("Abbrechen");
            mData.push("Ja, akuelle Ansicht drucken!");
            mData.push(() => { this.handleCallbackCancelModalAreYouSure(); window.print(); });
            mData.push(true);
            fix = 1;
        }
        else if (which === 'confirm_exam_save_auto_filename') {
            const fn = this.genFilename();
            mData.push("Klassenarbeit speichern");
            mData.push('Ihr Browser unterbindet das Anzeigen eines "Speichern unter..." Dialogs. ' +
                'Die aktuelle Klassenarbeit wird unter dem Dateinamen "' + fn +
                '" in den "Download"-Ordner gespeichert. Möchten Sie fortfahren?');
            mData.push("Abbrechen");
            mData.push("Ja, speichern!");
            mData.push((e) => this.handleDirectSaveExecute(fn));
            mData.push(true);
            fix = 1;
        }
        else if (which === 'confirm_exam_save_auto_filename_csv') {
            const fn = this.genFilename(false);
            mData.push("Klassenarbeit im CSV Format exportieren");
            mData.push('Leider kann für den Export kein "Speichern unter..." Dialog angezeigt werden. ' +
                'Die aktuelle Klassenarbeit wird unter dem Dateinamen "' + fn +
                '" in den "Download"-Ordner im CSV-Format gespeichert. Möchten Sie fortfahren?');
            mData.push("Abbrechen");
            mData.push("Ja, exportieren!");
            mData.push((e) => this.handleSaveCSVExecute(fn));
            mData.push(true);
            fix = 1;
        }

        if (fix !== 0) {
            this.setState(prevState => {
                let updatedItem = { ...prevState.helper.modalAYS };
                updatedItem.header = mData[0];
                updatedItem.body = mData[1];
                updatedItem.footer_cancel = mData[2];
                updatedItem.footer_confirm = mData[3];
                updatedItem.method_confirm = mData[4];
                updatedItem.visible = mData[5];
                return { helper: { ...prevState.helper, modalAYS: updatedItem } };
            })
        }
    }

    handlePrint = () => {
        if (this.gridRef && this.gridRef.current && this.gridRef.current.getGridApi()) {

            this.fixStateDataFromGrid(this.gridRef.current.getGridApi());
            // console.log(this.state);

            const maxN = genMinMaxAvgNote(this.state);
            const maxP = genMinMaxAvgPunkte(this.state);

            let printHTML = '<!DOCTYPE html><html lang="de"><head><meta charset="utf-8" />';
            printHTML += '<style>body{color: black; font-size: 14px; font-family: Roboto, arial;}';
            printHTML += 'table {width: 100%;}';
            printHTML += 'th, td {border: 1px solid grey;}.bolder{font-weight: bolder;}';
            printHTML += '</style>';
            printHTML += '</head><body><div style="margin-left: 50px;">';
            // let c = this.state.columns;
            let gr = this.state.grid;

            let cab = this.state.namelessColsAbereiche;
            let ab = this.state.abereiche;
            let tn = this.state.taskNames;

            // let cmp = this.state.namelessColsMaxPunkte;
            let mp = this.state.maxPunkte;

            // printHTML += "Dateiname: " + genFilename() + "<br>";
            printHTML += "Schuljahr: " + this.state.schuljahr + "<br>";
            printHTML += "Fach: " + this.state.fach + "<br>";
            printHTML += "Klasse: " + this.state.klasse + "<br>";;
            printHTML += "SchülerInnen: " + this.state.grid.length + "<br>";;
            printHTML += "Punkte (min/max/avg): " + maxP[0] + " / " + maxP[1] + " / " + maxP[2] + "<br>";;
            printHTML += "Noten (min/max/avg): " + maxN[0] + " / " + maxN[1] + " / " + maxN[2] + "<br>";;

            printHTML += "<table id='printTable'><tr><td colspan='2' style='border: none;'>&nbsp;</td>";
            var col;
            for (col = 2; col < cab.length; col++) {
                let aName = tn[0][col].value;
                // console.log(aName.length);
                if (aName.length === 0) {
                    aName = "A" + (col - 1);
                }
                // printHTML += "<th>" + cab[col].label + "</th>";
                printHTML += "<th>" + aName + "</th>";
            }
            printHTML += "<th>Summe</th><th>Note</th></tr>";

            printHTML += '<tr><td colspan="2"><span class="bolder">Anforderungsbereiche</span></td>';
            for (col = 2; col < ab[0].length; col++) {
                printHTML += "<td>" + ab[0][col].value + "</td>";
            }
            printHTML += "<td>&nbsp;</td><td>&nbsp;</td></tr>";

            printHTML += '<tr><td colspan="2"><span class="bolder">Maximalpunkte</span></td>';
            for (col = 2; col < mp[0].length; col++) {
                printHTML += "<td>" + mp[0][col].value + "</td>";
            }
            printHTML += "<td>&nbsp;</td></tr>";

            printHTML += '<tr><td><span class="bolder">Name</span></td><td><span class="bolder">Vorname</span></td>';
            printHTML += "<td colspan='" + (mp[0].length - 1) + "'></td>";
            printHTML += "</tr>";

            for (var row = 0; row < gr.length; row++) {
                printHTML += "<tr>";
                for (col = 0; col < gr[row].length; col++) {
                    const cellValue = gr[row][col]?.value ?? '';
                    printHTML += "<td>" + cellValue + "</td>";
                }
                printHTML += "</tr>";
            }

            printHTML += "</table></div></body></html>";

            var pri = document.getElementById("ifprint").contentWindow;
            pri.document.open();
            pri.document.write(printHTML);
            pri.document.close();
            pri.focus();
            pri.print();
        }
        else {
            this.goModal('confirm_print_current_view');
            // window.print();
        }
    }

    render() {
        if (this.state.helper.redirect !== "") {
            // XXX
            return <Navigate to="/erfassung" />;
        }
        return (
            <>
                <ModalConsentGate>
                    <div className="move-right content-wrapper offcanvas-open">

                        <NavbarTop
                            parentState={this.state}
                            backCallerHandleToggleOffCanvas={this.handleCallbackToggleOffCanvas}
                            backCallerHandlePrint={this.handlePrint}
                            // backCallerHandleReset={this.handleCallbackReset.bind(this)}
                            backCallerGoModal={this.goModal}
                            backCallerHandleToggleTooltips={this.handleCallbackToggleTooltips}
                        />

                        <Container fluid>
                            <main className="container-fluid mt-5 mb-5">
                                <h1 className="mt-4">{strToolNameHeadline} <span id="printDateTime">Zeitpunkt: {getDateTimeString()}</span></h1>

                                <Routes>
                                    <Route path="/erfassung/auswertung" element={<EvaluationPerform
                                        parentState={this.state}
                                        callbackHandleSetCriteria={this.handleSetCriteria}
                                        callbackHandleSetStatusInfo={this.handleCallbackSetNotice}
                                    />} />
                                    <Route path="*" element={
                                        <MainGrid parentState={this.state}
                                            callbackClipBoard={this.readClipboardContents}
                                            callbackTest={this.testCallBack}
                                            callbackHandleFileLoadClick={this.handleFileLoadClick}
                                            callbackHandleFileLoadChange={this.handleFileLoadChange}
                                            callbackHandleSetStatusInfo={this.handleCallbackSetNotice}
                                            callbackHandleSetGK={this.handleSetGK}
                                            callbackHandleGetGK={this.handleGetGK}
                                            callbackHandleSetRealMaxPoints={this.handleSetRealMaxPoints}
                                            callbackHandleGetRealMaxPoints={this.handleGetRealMaxPoints}
                                            callbackHandleReset={this.handleReset}
                                            callbackHandleSave={this.handleSave}
                                            callbackHandleSaveCSV={this.handleSaveCSV}
                                            callbackHandleStatusNotice={this.handleStatusNotice}
                                            // callbackHandleStatusNotice={this.handleCallbackSetNotice}
                                            callbackHandleSetLoadedJSON={this.handleSetLoadedJSON}
                                            callbackHandleChangeKlasse={this.handleChangeKlasse}
                                            callbackHandleChangeSchuljahr={this.handleChangeSchuljahr}
                                            callbackHandleChangeFach={this.handleChangeFach}
                                            callbackHandleChangeSockelOben={this.handleChangeSockelOben}
                                            callbackHandleChangeSockelUnten={this.handleChangeSockelUnten}
                                            callbackHandleChangeKnick={this.handleChangeKnick}
                                            callbackHandleChangeRealMaxPoints={this.handleChangeRealMaxPoints}
                                            callbackHandleChangeNotenschluessel={this.handleChangeNotenschluessel}
                                            callbackHandleChangeSumOfPupil={this.handleChangeSumOfPupil}
                                            callbackHandleClipboardData={this.handleClipboardData}
                                            callbackHandleSetMaxPointsSum={this.handleSetMaxPointsSum}
                                            callbackHandleNumOfTasks={this.handleChangeNumOfTasks}
                                            callbackHandleNumOfPupils={this.handleChangeNumOfPupils}
                                            callbackHandleFixStateDataFromGrid={this.fixStateDataFromGrid}
                                            callbackCheckClipBoardAccessRead={this.checkClipBoardAccessRead}
                                            callbackCheckClipBoardAccessWrite={this.checkClipBoardAccessWrite}
                                            callbackSetClipBoardAccess={this.setClipBoardAccess}
                                            callbackGetMaxPointsSum={this.handleGetMaxPointsSum}
                                            ref={this.gridRef}
                                        >
                                        </MainGrid>
                                    } />
                                    {/* <Route path="*" element={<PageNotFound />} /> */}

                                </Routes >
                            </main>
                        </Container>
                    </div>

                    <Navigation
                        parentState={this.state}
                        backCallerHandleToggleOffCanvas={this.handleCallbackToggleOffCanvas}
                        // backCallerHandleCollapse={this.handleCallbackCollapse}
                        backCallerHandleReset={this.handleCallbackReset.bind(this)}
                        backCallerHandlePrint={this.handlePrint}
                        callbackHandleFileLoadChange={this.handleFileLoadChange}
                        callbackHandleSave={this.handleSave}
                        callbackHandleSaveCSV={this.handleSaveCSV}
                        backCallerHandleWIPModal={this.handleCallbackWIPModal}
                        callbackHandleFixStateDataFromGrid={this.fixStateDataFromGrid}
                        callbackHandleFixStateDataFromGridFromApp={this.fixStateDataFromGridFromApp}

                    />

                    <ModalAreYouSure
                        className="no-print"
                        parentState={this.state}
                        backCallerHandleCancelModalAreYouSure={this.handleCallbackCancelModalAreYouSure}
                    />

                    <Toasts
                        parentState={this.state}
                        backCallerHandleToggleToast={this.handleCallbackToggleToast}
                    />
                    <iframe title="ifprint" id="ifprint"></iframe>
                </ModalConsentGate>
            </>
        );
    }
}

window.addEventListener("unhandledrejection", (event) => {
    console.warn(`PROMISE REJECTION: ${event.reason}`);
    console.warn(event);
    event.preventDefault();
});

export default App;
